<script setup lang="ts">
import { ArrowRight, Mail, MapPin, Phone } from "lucide-vue-next";
import "@/assets/styles/contact.css";
</script>

<template>
  <section class="contact-section" id="contact">
    <div class="section-shell contact-shell reveal">
      <div class="contact-copy">
        <span class="eyebrow light">Ihr Projekt beginnt hier</span>
        <h2>Was können wir für Sie <em>wachsen lassen?</em></h2>
        <p>Erzählen Sie uns kurz von Ihrem Vorhaben. Wir melden uns persönlich und sprechen über den sinnvollsten nächsten Schritt.</p>
        <div class="contact-details">
          <a href="tel:+496111234567"><Phone /><span><small>Direkt anrufen</small>+49 611 123 45 67</span></a>
          <a href="mailto:projekt@freiraum-galabau.de"><Mail /><span><small>E-Mail schreiben</small>projekt@freiraum-galabau.de</span></a>
          <div><MapPin /><span><small>Unser Einsatzgebiet</small>Rhein-Main & Umgebung</span></div>
        </div>
      </div>
      <form class="contact-form" @submit.prevent>
        <div class="form-row"><label>Name<input type="text" placeholder="Wie dürfen wir Sie ansprechen?" /></label><label>Unternehmen<input type="text" placeholder="Optional" /></label></div>
        <label>E-Mail<input type="email" placeholder="name@unternehmen.de" /></label>
        <label>Worum geht es?<select><option>Neue Außenanlage</option><option>Pflege & Service</option><option>Privatgarten</option><option>Sonstiges Projekt</option></select></label>
        <label>Ihre Nachricht<textarea rows="4" placeholder="Ein paar Stichpunkte zu Fläche, Ort und Wunsch ..." /></label>
        <button type="submit">Unverbindlich anfragen <ArrowRight /></button>
        <small class="form-note">Wir melden uns in der Regel innerhalb eines Werktags.</small>
      </form>
    </div>
  </section>
</template>
